import _ from "lodash";
import { API_BASE_URL, PlataformaId } from "../config/api";

interface Vinculo {
  seccion: any;
  seccion_destacada: any;
  id: string;
  id_seccion: string;
  titulo: string;
}

export const getVinculosAdmin = async ({ id, plataforma, isPublic }: { id: string; plataforma: PlataformaId; isPublic: boolean }): Promise<Vinculo[]> => {
  const formData = new FormData();
  formData.append('listar_vinculos', 'true');
  formData.append('plataforma', String(plataforma));
  formData.append('seccion', String(id));
  formData.append('public', String(isPublic));
  return sendRequest(formData);
};

export const sendRequest = async (body: FormData): Promise<any> => {
  return new Promise((resolve, reject) => {
    fetch(`${API_BASE_URL}/cliente.php`, {
      method: "POST",
      body,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          reject(new Error(data.error || 'Unknown error occurred'));
        }
        resolve(data.resp);
      })
      .catch((error) => {
        reject(new Error(error.message || 'Network error occurred'));
      });
  });
}

export const getInfo = async (context: any, hash: any, plataforma?: PlataformaId): Promise<boolean> => {
  try {
    const resultString = hash as string;
    const plataformaId = plataforma ?? context?.plataforma ?? 1;

    const formData = new FormData();
    formData.append("data", resultString);
    formData.append("plataforma", String(plataformaId));

    const response = await fetch(`${API_BASE_URL}/cliente.php`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    const payload = {
      vinculos: data.resp || [], // Nos aseguramos de que no sea undefined
      perfil: data.perfil,
      secciones: getInfoBody(data.resp || []),
      isSoporte: data.isSoporte,
      plataforma: data.plataforma ?? plataformaId,
    };

    context?.setData((prevData: any) => ({
      ...prevData,
      ...payload,
    }));

    localStorage.setItem("data", JSON.stringify(payload));
    return true;
  } catch (error) {
    console.error("Error en getInfo:", error);
    return false;
  }
};

export const saveVinculosOrder = async (vinculos: Vinculo[]): Promise<boolean> => {
  try {
    const formData = new FormData();
    formData.append('ordenar_vinculos', 'true');
    formData.append('vinculos', JSON.stringify(vinculos));

    const response = await fetch(`${API_BASE_URL}/cliente.php`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    if (data.error) {
      throw new Error(data.error || 'Error al guardar el orden de los vínculos');
    }
    return true;
  } catch (error) {
    console.error("Error en saveVinculosOrder:", error);
    return false;
  }
}

export interface SeccionAdmin {
  id: number;
  seccion: string;
  seccion_destacada: number;
  id_producto: number;
  id_plataforma: number;
}

export const getSeccionesAdmin = async (plataforma: PlataformaId): Promise<SeccionAdmin[]> => {
  const formData = new FormData();
  formData.append('listar_secciones', 'true');
  formData.append('plataforma', String(plataforma));
  return sendRequest(formData);
};

export const saveSeccion = async (data: {
  id?: number;
  seccion: string;
  seccion_destacada: number;
  id_producto: number;
  id_plataforma: number;
}): Promise<{ id: number; success: boolean }> => {
  const formData = new FormData();
  formData.append('guardar_seccion', 'true');
  if (data.id) formData.append('id', String(data.id));
  formData.append('seccion', data.seccion);
  formData.append('seccion_destacada', String(data.seccion_destacada));
  formData.append('id_producto', String(data.id_producto));
  formData.append('id_plataforma', String(data.id_plataforma));
  return sendRequest(formData);
};

// export const uploadFile = async (
//   file: File,
//   tipo: 'video' | 'imagen' | 'documento',
//   onProgress?: (porcentaje: number) => void // <-- Nuevo Callback
// ): Promise<string> => {
//   const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB por fragmento
//   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
//   const fileId = `${btoa(file.name).replace(/[^a-zA-Z0-9]/g, '')}_${file.size}_${Date.now()}`;

//   let finalUrl = '';

//   for (let index = 0; index < totalChunks; index++) {
//     const start = index * CHUNK_SIZE;
//     const end = Math.min(start + CHUNK_SIZE, file.size);
//     const chunk = file.slice(start, end);

//     const formData = new FormData();
//     formData.append('file', chunk);
//     formData.append('tipo', tipo);
//     formData.append('chunkIndex', index.toString());
//     formData.append('totalChunks', totalChunks.toString());
//     formData.append('fileId', fileId);
//     formData.append('fileName', file.name);

//     const response = await fetch(`${API_BASE_URL}/upload.php`, {
//       method: 'POST',
//       body: formData,
//     });

//     const data = await response.json();

//     if (!response.ok || data.error) {
//       throw new Error(data.error || `Error al subir el fragmento ${index + 1}`);
//     }

//     if (data.url) {
//       finalUrl = data.url;
//     }

//     // Calcular el porcentaje en base a los fragmentos completados y notificar
//     if (onProgress) {
//       const porcentajeCompletado = Math.round(((index + 1) / totalChunks) * 100);
//       onProgress(porcentajeCompletado);
//     }
//   }

//   if (!finalUrl) {
//     throw new Error('No se recibió la URL de confirmación del archivo completo.');
//   }

//   return finalUrl;
// };

export const uploadFile = async (
  file: File,
  tipo: 'video' | 'imagen' | 'documento',
  onProgress?: (porcentaje: number) => void
): Promise<string> => {
  const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB por fragmento
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const fileId = `${btoa(file.name).replace(/[^a-zA-Z0-9]/g, '')}_${file.size}_${Date.now()}`;
  
  const CONCURRENCY_LIMIT = 3; // Enviar hasta 3 fragmentos simultáneos
  
  // Array para rastrear cuántos bytes ha subido cada fragmento individualmente
  const chunksUploadedBytes = new Array(totalChunks).fill(0);

  // Crear la cola de índices de fragmentos pendientes
  const chunksQueue = Array.from({ length: totalChunks }, (_, index) => index);

  // Variable para almacenar la respuesta del backend
  let finalUrl = '';

  // Función trabajadora (Worker) que procesará la cola concurrentemente
  const uploadWorker = async () => {
    while (chunksQueue.length > 0) {
      const index = chunksQueue.shift(); // Tomar el siguiente fragmento disponible
      if (index === undefined) break;

      const start = index * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      const chunkSize = end - start;

      const formData = new FormData();
      formData.append('file', chunk);
      formData.append('tipo', tipo);
      formData.append('chunkIndex', index.toString());
      formData.append('totalChunks', totalChunks.toString());
      formData.append('fileId', fileId);
      formData.append('fileName', file.name);

      try {
        // Usamos XMLHttpRequest en lugar de fetch para poder medir el progreso real en bytes
        await new Promise<void>((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('POST', `${API_BASE_URL}/upload.php`);

          // Monitorear progreso de subida de este chunk específico
          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && onProgress) {
              chunksUploadedBytes[index] = event.loaded;
              
              // Sumar el total de bytes subidos entre todos los chunks activos y terminados
              const totalUploadedBytes = chunksUploadedBytes.reduce((acc, curr) => acc + curr, 0);
              const porcentaje = Math.min(Math.round((totalUploadedBytes / file.size) * 100), 100);
              onProgress(porcentaje);
            }
          };

          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              try {
                const data = JSON.parse(xhr.responseText);
                if (data.error) {
                  reject(new Error(data.error));
                } else {
                  // Asegurar que registramos el tamaño completo al finalizar el chunk
                  chunksUploadedBytes[index] = chunkSize;
                  if (data.url) finalUrl = data.url;
                  resolve();
                }
              } catch (e) {
                reject(new Error(`Respuesta inválida del servidor en fragmento ${index + 1}`));
              }
            } else {
              reject(new Error(`Error de servidor (${xhr.status}) en fragmento ${index + 1}`));
            }
          };

          xhr.onerror = () => reject(new Error(`Error de red en fragmento ${index + 1}`));
          xhr.send(formData);
        });

      } catch (error) {
        // Si falla por red o saturación temporal, lo devolvemos a la cola para reintentar
        console.warn(`Fallo en fragmento ${index + 1}. Reintentando...`, error);
        chunksQueue.push(index);
        await new Promise((res) => setTimeout(res, 1500)); // Espera un segundo antes de reintentar
      }
    }
  };

  // Lanzar los hilos de trabajo paralelos
  const workers = Array.from({ length: CONCURRENCY_LIMIT }, () => uploadWorker());
  await Promise.all(workers);

  if (!finalUrl) {
    throw new Error('No se recibió la URL de confirmación del archivo completo.');
  }

  // Asegurar el 100% visual al terminar con éxito todo el proceso
  if (onProgress) onProgress(100);

  return finalUrl;
};

export const getPerfil = async (): Promise<string> => {
  return new Promise((resolve) => {
    const perfil = localStorage.getItem('perfil') || '';
    resolve(perfil);
  });
}

export const sendVisit = (id: string, colum: string) => {
  let formData = new FormData();
  formData.append(colum, id);
  fetch(`${API_BASE_URL}/cliente.php`, {
    method: "POST",
    body: formData,
  });
}

export const converHtml = (string: string) => {
  let entityMap = p;
  for (let key in entityMap) {
    let entity = entityMap[key];
    let regex = new RegExp(entity, 'g');
    string = string.replace(regex, key);
  }
  string = string.replace(/&quot;/g, '"');
  string = string.replace(/&amp;/g, '&');
  return string;
}

export const getInfoBody = (vinculos: Vinculo[]) => {
  let seccion: { [key: string]: any } = {};
  let seccionF: any[] = [];
  let i = 0;
  let j = 1;
  vinculos.forEach((element) => {
    if (!seccion[element.id_seccion]) {
      seccion[element.id_seccion] = {};
    }
    seccion[element.id_seccion]["destacada"] = element.seccion_destacada;
    seccion[element.id_seccion]["id_seccion"] = element.id_seccion;
    seccion[element.id_seccion]["seccion"] = element.seccion;
  });

  _.forEach(seccion, (element: { destacada: number; number: number; }) => {
    if (!seccionF[i]) {
      seccionF[i] = {};
    }
    if (element.destacada === 0) {
      element.number = j;
      j++;
    }
    seccionF[i] = element;
    i++;
  });
  return seccionF;
};

const p: any = {
  "'": "&apos;",
  "<": "&lt;",
  ">": "&gt;",
  " ": "&nbsp;",
  "¡": "&iexcl;",
  "¢": "&cent;",
  "£": "&pound;",
  "¤": "&curren;",
  "¥": "&yen;",
  "¦": "&brvbar;",
  "§": "&sect;",
  "¨": "&uml;",
  "©": "&copy;",
  "ª": "&ordf;",
  "«": "&laquo;",
  "¬": "&not;",
  "®": "&reg;",
  "¯": "&macr;",
  "°": "&deg;",
  "±": "&plusmn;",
  "²": "&sup2;",
  "³": "&sup3;",
  "´": "&acute;",
  "µ": "&micro;",
  "¶": "&para;",
  "·": "&middot;",
  "¸": "&cedil;",
  "¹": "&sup1;",
  "º": "&ordm;",
  "»": "&raquo;",
  "¼": "&frac14;",
  "½": "&frac12;",
  "¾": "&frac34;",
  "¿": "&iquest;",
  "À": "&Agrave;",
  "Á": "&Aacute;",
  "Â": "&Acirc;",
  "Ã": "&Atilde;",
  "Ä": "&Auml;",
  "Å": "&Aring;",
  "Æ": "&AElig;",
  "Ç": "&Ccedil;",
  "È": "&Egrave;",
  "É": "&Eacute;",
  "Ê": "&Ecirc;",
  "Ë": "&Euml;",
  "Ì": "&Igrave;",
  "Í": "&Iacute;",
  "Î": "&Icirc;",
  "Ï": "&Iuml;",
  "Ð": "&ETH;",
  "Ñ": "&Ntilde;",
  "Ò": "&Ograve;",
  "Ó": "&Oacute;",
  "Ô": "&Ocirc;",
  "Õ": "&Otilde;",
  "Ö": "&Ouml;",
  "×": "&times;",
  "Ø": "&Oslash;",
  "Ù": "&Ugrave;",
  "Ú": "&Uacute;",
  "Û": "&Ucirc;",
  "Ü": "&Uuml;",
  "Ý": "&Yacute;",
  "Þ": "&THORN;",
  "ß": "&szlig;",
  "à": "&agrave;",
  "á": "&aacute;",
  "â": "&acirc;",
  "ã": "&atilde;",
  "ä": "&auml;",
  "å": "&aring;",
  "æ": "&aelig;",
  "ç": "&ccedil;",
  "è": "&egrave;",
  "é": "&eacute;",
  "ê": "&ecirc;",
  "ë": "&euml;",
  "ì": "&igrave;",
  "í": "&iacute;",
  "î": "&icirc;",
  "ï": "&iuml;",
  "ð": "&eth;",
  "ñ": "&ntilde;",
  "ò": "&ograve;",
  "ó": "&oacute;",
  "ô": "&ocirc;",
  "õ": "&otilde;",
  "ö": "&ouml;",
  "÷": "&divide;",
  "ø": "&oslash;",
  "ù": "&ugrave;",
  "ú": "&uacute;",
  "û": "&ucirc;",
  "ü": "&uuml;",
  "ý": "&yacute;",
  "þ": "&thorn;",
  "ÿ": "&yuml;",
  "Œ": "&OElig;",
  "œ": "&oelig;",
  "Š": "&Scaron;",
  "š": "&scaron;",
  "Ÿ": "&Yuml;",
  "ƒ": "&fnof;",
  "ˆ": "&circ;",
  "˜": "&tilde;",
  "Α": "&Alpha;",
  "Β": "&Beta;",
  "Γ": "&Gamma;",
  "Δ": "&Delta;",
  "Ε": "&Epsilon;",
  "Ζ": "&Zeta;",
  "Η": "&Eta;",
  "Θ": "&Theta;",
  "Ι": "&Iota;",
  "Κ": "&Kappa;",
  "Λ": "&Lambda;",
  "Μ": "&Mu;",
  "Ν": "&Nu;",
  "Ξ": "&Xi;",
  "Ο": "&Omicron;",
  "Π": "&Pi;",
  "Ρ": "&Rho;",
  "Σ": "&Sigma;",
  "Τ": "&Tau;",
  "Υ": "&Upsilon;",
  "Φ": "&Phi;",
  "Χ": "&Chi;",
  "Ψ": "&Psi;",
  "Ω": "&Omega;",
  "α": "&alpha;",
  "β": "&beta;",
  "γ": "&gamma;",
  "δ": "&delta;",
  "ε": "&epsilon;",
  "ζ": "&zeta;",
  "η": "&eta;",
  "θ": "&theta;",
  "ι": "&iota;",
  "κ": "&kappa;",
  "λ": "&lambda;",
  "μ": "&mu;",
  "ν": "&nu;",
  "ξ": "&xi;",
  "ο": "&omicron;",
  "π": "&pi;",
  "ρ": "&rho;",
  "ς": "&sigmaf;",
  "σ": "&sigma;",
  "τ": "&tau;",
  "υ": "&upsilon;",
  "φ": "&phi;",
  "χ": "&chi;",
  "ψ": "&psi;",
  "ω": "&omega;",
  "ϑ": "&thetasym;",
  "ϒ": "&Upsih;",
  "ϖ": "&piv;",
  "–": "&ndash;",
  "—": "&mdash;",
  "‘": "&lsquo;",
  "’": "&rsquo;",
  "‚": "&sbquo;",
  "“": "&ldquo;",
  "”": "&rdquo;",
  "„": "&bdquo;",
  "†": "&dagger;",
  "‡": "&Dagger;",
  "•": "&bull;",
  "…": "&hellip;",
  "‰": "&permil;",
  "′": "&prime;",
  "″": "&Prime;",
  "‹": "&lsaquo;",
  "›": "&rsaquo;",
  "‾": "&oline;",
  "⁄": "&frasl;",
  "€": "&euro;",
  "ℑ": "&image;",
  "℘": "&weierp;",
  "ℜ": "&real;",
  "™": "&trade;",
  "ℵ": "&alefsym;",
  "←": "&larr;",
  "↑": "&uarr;",
  "→": "&rarr;",
  "↓": "&darr;",
  "↔": "&harr;",
  "↵": "&crarr;",
  "⇐": "&lArr;",
  "⇑": "&UArr;",
  "⇒": "&rArr;",
  "⇓": "&dArr;",
  "⇔": "&hArr;",
  "∀": "&forall;",
  "∂": "&part;",
  "∃": "&exist;",
  "∅": "&empty;",
  "∇": "&nabla;",
  "∈": "&isin;",
  "∉": "&notin;",
  "∋": "&ni;",
  "∏": "&prod;",
  "∑": "&sum;",
  "−": "&minus;",
  "∗": "&lowast;",
  "√": "&radic;",
  "∝": "&prop;",
  "∞": "&infin;",
  "∠": "&ang;",
  "∧": "&and;",
  "∨": "&or;",
  "∩": "&cap;",
  "∪": "&cup;",
  "∫": "&int;",
  "∴": "&there4;",
  "∼": "&sim;",
  "≅": "&cong;",
  "≈": "&asymp;",
  "≠": "&ne;",
  "≡": "&equiv;",
  "≤": "&le;",
  "≥": "&ge;",
  "⊂": "&sub;",
  "⊃": "&sup;",
  "⊄": "&nsub;",
  "⊆": "&sube;",
  "⊇": "&supe;",
  "⊕": "&oplus;",
  "⊗": "&otimes;",
  "⊥": "&perp;",
  "⋅": "&sdot;",
  "⌈": "&lceil;",
  "⌉": "&rceil;",
  "⌊": "&lfloor;",
  "⌋": "&rfloor;",
  "⟨": "&lang;",
  "⟩": "&rang;",
  "◊": "&loz;",
  "♠": "&spades;",
  "♣": "&clubs;",
  "♥": "&hearts;",
  "♦": "&diams;"
}  